export const environment = {
	production: false,
	apiBaseUrl: 'https://api-dev.aldorartour.com/api/v1',
	// Tenant publik yang ditampilkan landing page (data multi-tenant di-scope per tenant).
	tenant: {
		// Slug tenant (cara yang disarankan) — dikirim sebagai ?tenant= / header X-Tenant.
		slug: 'demo-tour',
		// Bila landing dilayani per-subdomain (mis. aldorar.contoh.com), set true untuk
		// mendeteksi subdomain dari host browser & mengirim X-Tenant-Subdomain.
		resolveFromSubdomain: false,
		// Domain dasar untuk memotong bagian subdomain dari window.location.host.
		rootDomain: 'aldorartour.com',
	},
	// Fallback identitas & kontak. Sumber UTAMA = API GET /public/tenant-profile
	// (TenantProfileService). Nilai di sini hanya dipakai bila API gagal/kosong.
	// Kantor (offices) kini dinamis dari tenant_branches; tak perlu di-bake.
	brand: {
		name: 'Demo Tour',
		tagline: 'Sahabat Perjalanan Ibadah Anda',
		phone: '+62 819-9237-289',
		whatsapp: '6281992372899',
		email: 'cs@demotour.com',
		address: 'Jl. Casablanca Raya No. 88, Jakarta Selatan, Indonesia',
		instagram: 'https://instagram.com/demotour',
		facebook: 'https://facebook.com/demotour',
		youtube: 'https://youtube.com/@demotour',
	},
};
